import { Component, OnInit, Inject, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { GlobalService } from '../service/global.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,

  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';
import { Router } from '@angular/router';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { StateInfo } from '../model/StateInfo.model';
import { DatePipe, Location } from '@angular/common';
import { LeadTansactionInfo } from '../model/leadtansaction.model';

@Component({
  selector: 'app-projectsale-management',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './projectsale-management.component.html',
  styleUrls: ['./projectsale-management.component.css']
})
export class ProjectsaleManagementComponent implements OnInit {

  form: FormGroup;

  // ------------------------------- Assign Manager Zone -----------------------------------------------
  AssignBDForm: FormGroup
  AssignBDList: EmpInfo[] = [];
  cuurentselectProjectAssignBD: string = null
// ------------------------------- Assign Manager Zone -----------------------------------------------

  public body: string;
  ProjectSaleListPromise: Promise<ProjectSaleInfo[]>
  ProjectSaleList: ProjectSaleInfo[] = []
  ProjectSaleListPromisereturn: Promise<ProjectSaleInfo[]>[]
  CompanyList: CompanyInfo[] = []
  CategoryList: LookupInfo[] = []
  StatusList: LookupInfo[] = []
  StateList: StateInfo[] = []
  ProjectSaleTypeList: LookupInfo[] = [];
  ProjectSalePhaseList: LookupInfo[] = [];
  ProjectSaleCustomerTypeList: LookupInfo[] = [];
  empList: EmpInfo[] = [];
  empListLoad: EmpInfo[] = [];
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>
  saleOrganizationList: SaleOrganizationInfo[] = [];
  saleOrganizationPromise: Promise<SaleOrganizationInfo[]>
  saleOrganizationMaxList: SaleOrganizationInfo[] = [];
  pastYearList: any[] = [];

  // array control
  itemsSupport: FormArray;

  flagduplicate: boolean;
  hidProjectSaleId: number;
  hidProjectSaleState: string;
  hidProjectRequestType: string;

  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number

  public empcodeinit: string
  _EmpCode: string;
  _RoleCode: string;
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;

  public currentPageNumberEmp: number
  public totalPagesEmp: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean = false;
  isViewOnly: boolean = false;
  isSubmitted: any;

  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number

  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;

  baseurl: string;
  expense_baseurl: string;

  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[];
  today: string;

  isSearchSubmitted: boolean = false;

  titlemodal: string;
  detailmodal: string;

  // Add new properties
  ChannelTypeList: any[] = [];
  ChannelMappingDList: any[] = [];
  ChannelMappingCList: any[] = [];
  isDealerChannel: boolean = false;

  // Lead Transaction properties
  LeadTransaction: LeadTansactionInfo[] = [];
  totalLeadTransaction: number;
  totalPages_LeadTransac: number;
  currentPageNumber_LeadTransac: number = 1;

  searchCompanyText: string = '';
filteredCompanyList: any[] = [];
showCompanyDropdown: boolean = false;


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router, private location: Location) {
    this.baseurl = environment.base_api;
    this.expense_baseurl = environment.expense_base_api;
    GlobalService.CheckPagingAccessRights();

  }

  async ngOnInit() {
    this.today = new Date().toLocaleDateString('en-CA');
    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSize;

    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");
    this.currentPageNumberEmp = 1;

    this.monthNameslist = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    this.yearlist = this.generateArrayOfYears();
    this.pastYearList = this.generateArrayOfPastYears(10);
    this.form = this.formBuilder.group({
      ProjectSaleCodeSearch: [null],
      ProjectSaleNameSearch: [null],
      ProjectSaleCompanyIdSearch: [null],
      ProjectSaleStatusSearch: [null],
      ProjectSaleStateSearch: [null],

      ProjectGroupMapping: [null],
      ProjectSaleCode: [null],
      ProjectSaleName: [null, Validators.required],
      ProjectSaleCompanyId: [null, Validators.required],
      ProjectSaleStatus: [null, Validators.required],
      ProjectSaleType: [null, Validators.required],
      ProjectSaleCategory: [null, Validators.required],
      ProjectSaleTool: [null],
      ProjectSalePhase: [null, Validators.required],
      ProjectSaleBudget: [null],
      ProjectSaleExpectedClosePeriodMonth: [null],
      ProjectSaleExpectedClosePerioddYear: [null],
      ProjectSaleContactDate: [null, Validators.required],
      ProjectSaleContactPerson: [null, Validators.required],
      ProjectSaleContactEmail: [null],
      ProjectSaleContactTel: [null, Validators.required],
      ProjectSaleCustomerType: [null, Validators.required],
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      ProjectSaleRemark: [null],
      ProjectSaleYear: [null, Validators.required],

      EmpCodeSearch: [null],
      EmpNameSearch: [null],
      // Assign BD Form
      AssignBDForm : this.formBuilder.group({
        ddlAssignBD: [null, Validators.required],
      }),
      ProjectSaleChannelTypeCode: [null],
      ProjectSaleChannelMappingCode: [null]
    });

    // set Assign BD Form
    this.AssignBDForm = this.form.get('AssignBDForm') as FormGroup;

    

    this.Clearinput();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      this.loadCompany(auth_token).then((data) => {
        // Sort the array by CompanyName
        data.sort((a, b) => a.CompanyName.localeCompare(b.CompanyName));

        this.CompanyList = data;
      });

      this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
        this.CategoryList = data;
      });

      this.loadLookup('PROJECTSALESTATUS', auth_token).then((data) => {
        this.StatusList = data;
      });

      this.loadLookup('PROJECTSALETYPE', auth_token).then((data) => {
        this.ProjectSaleTypeList = data;
      });

      this.loadLookup('PROJECTSALEPHASE', auth_token).then((data) => {
        this.ProjectSalePhaseList = data;
      });

      this.loadLookup('COMPANYCUSTOMERTPYE', auth_token).then((data) => {
        this.ProjectSaleCustomerTypeList = data;
      });
      this.LoadStateList().then((data) => {
        this.StateList = data;
      });
      this.LoadSaleOrganizationLevel(auth_token);
      this.LoadListProjectGroup(auth_token);
      this.LoadCountProjectGroup(auth_token);

      // Load channel type data
      await this.loadChannelTypes(auth_token);
      
      // Load channel mapping data
      await this.loadChannelMapping(auth_token, 'D');
      await this.loadChannelMapping(auth_token, 'C');

    }
  }

  btnClick_SearchProjectSaleList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;

    this.isSearchSubmitted = true;
    this.LoadProjectSale()
  }
  Clearinput() {
    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var year = d.getFullYear();
    this.isSearchSubmitted = false;
    this.form.patchValue({
      ProjectGroupMapping: null,
      ProjectSaleCode: null,
      ProjectSaleName: null,
      ProjectSaleCompanyId: null,
      ProjectSaleStatus: null,
      ProjectSaleType: null,
      ProjectSaleCategory: null,
      ProjectSaleTool: null,
      ProjectSalePhase: null,
      ProjectSaleBudget: null,
      ProjectSaleExpectedClosePeriodMonth: null,
      ProjectSaleExpectedClosePerioddYear: null,
      ProjectSaleContactDate: null,
      ProjectSaleContactPerson: null,
      ProjectSaleContactEmail: null,
      ProjectSaleContactTel: null,
      ProjectSaleCustomerType: null,
      ProjectSaleRemark: null,
      ProjectSaleYear: null,
      ProjectSaleChannelTypeCode: null,
      ProjectSaleChannelMappingCode: null
    });

    // clear support team
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.clear();
    this.itemsSupport.push(this.createItemSupportTeamName());

  }

  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );

  }

  addSupport(): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.push(this.createItemSupportTeamName());
  }

  removeSupportItem(indexitem): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.removeAt(indexitem);
  }

  ClearSearch() {
    this.form.patchValue({
      ProjectSaleCodeSearch: "",
      ProjectSaleNameSearch: "",
      ProjectSaleCompanyIdSearch: "",
      ProjectSaleStatusSearch: "",
      ProjectSaleStateSearch: "",
    });

    this.searchCompanyText = "";        // ← reset ค่าที่แสดงใน textbox autocomplete
    this.filteredCompanyList = [];      // ← ล้าง dropdown ถ้ามีค้าง
    this.showCompanyDropdown = false;

    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.LoadProjectSale();
  }

  async LoadProjectSale(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleList(auth_token);
      this.LoadProjectSaleCountList(auth_token);
    }
  }

  LoadProjectSaleList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumber - 1) * this.environment;

    var objectjson = {};
    objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;
    objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value)) : 0;
    objectjson['ProjectSaleState'] = this.form.controls['ProjectSaleStateSearch'].value;

    objectjson['rowFetch'] = this.environment;
    objectjson['rowOFFSet'] = offset;
    objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";
    objectjson['ProjectSaleFlagOrderbyAssign'] = "Y";

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      .subscribe({
        next: (data) => {
          this.ProjectSaleList = data;

        }
      });


  }

  LoadProjectSaleCountList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };


    var objectjson = {};
    objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;
    objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value)) : 0;
    objectjson['ProjectSaleState'] = this.checkUndefinedString(this.form.controls['ProjectSaleStateSearch'].value);

    objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";


    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<number>(this.baseurl + "ProjectSale/GetCountProjectSale", strjson, httpOptions)
      .toPromise().then((data) => {


        this.hidcouchk = data;
        if (this.hidcouchk == 0) {
          this.currentPageNumber = 0;
          this.totalPages = 0;
        } else {
          this.totalPages = Math.ceil(this.hidcouchk / this.environment);
        }
      })


  }


  async LoadProjectSaleAll(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;
    objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value)) : 0;
    objectjson['ProjectSaleState'] = this.checkUndefinedString(this.form.controls['ProjectSaleStateSearch'].value);

    objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";

    if (this.viewflag == true) {

    }
    else {
      objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    }

    let strjson = JSON.stringify(objectjson);


    this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      .toPromise().then((data) => {
        this.countall = data.length;

        this.totalActive = data.filter(function (el) {
          return el.ProjectSaleStatusDisplay == 'Active'
        }).length;

        this.totalInActive = data.filter(function (el) {
          return el.ProjectSaleStatusDisplay == 'Inactive'
        }).length;

        this.totalHold = data.filter(function (el) {
          return el.ProjectSaleStatusDisplay == 'Hold'
        }).length;

        this.totalClosed = data.filter(function (el) {
          return el.ProjectSaleStatusDisplay == 'Closed'
        }).length;

      })


  }

  async btnClick_submitInsertProjectSale(saveType) {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        console.log('form submitted');
        this.OnCreating('y');

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectGroupMapping'] = this.checkUndefinedString(this.form.controls['ProjectGroupMapping'].value);
        objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleName'].value);
        objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value)) : 0;
        objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString($('#ProjectSaleCompanyId option:selected').attr('companyabbreviation'));
        objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value)) : 0;
        objectjson['ProjectSaleType'] = this.checkUndefinedString(this.form.controls['ProjectSaleType'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleType'].value)) : 0;
        objectjson['ProjectSaleTypeDisplay'] = this.checkUndefinedString($('#ProjectSaleType option:selected').attr('projectsaletypedisplay'));
        objectjson['ProjectSaleCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.checkUndefinedString(this.form.controls['ProjectSaleTool'].value);
        objectjson['ProjectSalePhase'] = this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value)) : 0;
        objectjson['ProjectSalePhaseDisplay'] = this.checkUndefinedString($('#ProjectSalePhase option:selected').attr('projectsalephasedisplay'));
        objectjson['ProjectSaleBudget'] = this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.checkUndefinedString(this.form.controls['ProjectSaleCustomerType'].value)
        objectjson['ProjectSaleSupportTeam'] = this.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.checkUndefinedString(this.form.controls['ProjectSaleRemark'].value);
        objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleRequestTypeCode'] = '1';
        objectjson['ProjectSaleYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) ? this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) : null;
        objectjson['ProjectSaleChannelTypeCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelTypeCode'].value);
        objectjson['ProjectSaleChannelMappingCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelMappingCode'].value);

        objectjson['ProjectSaleFlagDelete'] = "N";
        objectjson['ProjectSaleActiveFlag'] = "Y";
        objectjson['ProjectSaleState'] = saveType;

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/InsertProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
          },
            async () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              this.currentPageNumber = 1;
              this.indexNo = 0;
              var auth_token = await this.TokenService.RefreshToken();
              if (!!auth_token) {
                this.LoadProjectSale();
                this.LoadProjectSaleAll(auth_token);
              }

            }
          )

      } else {
        this.GlobalService.validateAllFormFields(this.form);
      }
    }
  }

  btnClick_onUpdateProjectSale(id) {
    $('#ModalProjectSale').modal('hide');
    this.Clearinput();
    this.isOnUpdate = true
    this.isViewOnly = false;
    this.router.navigateByUrl('/projectsale-information;status=u;id=' + id + '');

    //let index = this.ProjectSaleList.findIndex(x => x.ProjectSaleId == id);

    //// get json object from field SupportTeam
    //this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    //this.itemsSupport.clear();
    //var objectSupportTeamFromJson = [];
    //if (this.ProjectSaleList[index].ProjectSaleSupportTeam != null && this.ProjectSaleList[index].ProjectSaleSupportTeam != '') {
    //  objectSupportTeamFromJson = JSON.parse(this.ProjectSaleList[index].ProjectSaleSupportTeam);
    //}

    //for (let i = 0; i < objectSupportTeamFromJson.length; i++) {
    //  this.itemsSupport.push(this.createItemSupportTeamName(objectSupportTeamFromJson[i].SupporTeamName));
    //}

    //var d = new Date();
    //var monthindex = d.getMonth() + 1;
    //var yearcurrent = d.getFullYear();

    //this.form.patchValue({
    //  ProjectGroupMapping: this.ProjectSaleList[index].ProjectGroupMapping != null ? this.ProjectSaleList[index].ProjectGroupMapping : null,
    //  ProjectSaleCode: this.ProjectSaleList[index].ProjectSaleCode != null ? this.ProjectSaleList[index].ProjectSaleCode : null,
    //  ProjectSaleName: this.ProjectSaleList[index].ProjectSaleName != null ? this.ProjectSaleList[index].ProjectSaleName : null,
    //  ProjectSaleCompanyId: this.ProjectSaleList[index].ProjectSaleCompanyId != null ? this.ProjectSaleList[index].ProjectSaleCompanyId : null,
    //  ProjectSaleStatus: this.ProjectSaleList[index].ProjectSaleStatus != null ? this.ProjectSaleList[index].ProjectSaleStatus : null,
    //  ProjectSaleType: this.ProjectSaleList[index].ProjectSaleType != null ? this.ProjectSaleList[index].ProjectSaleType : null,
    //  ProjectSaleCategory: this.ProjectSaleList[index].ProjectSaleCategoryCode != null ? this.ProjectSaleList[index].ProjectSaleCategoryCode : null,
    //  ProjectSaleTool: this.ProjectSaleList[index].ProjectSaleTool != null ? this.ProjectSaleList[index].ProjectSaleTool : null,
    //  ProjectSalePhase: this.ProjectSaleList[index].ProjectSalePhase != null ? this.ProjectSaleList[index].ProjectSalePhase : null,
    //  ProjectSaleBudget: this.ProjectSaleList[index].ProjectSaleBudget != null ? this.ProjectSaleList[index].ProjectSaleBudget : null,
    //  ProjectSaleExpectedClosePeriodMonth: this.ProjectSaleList[index].ProjectSaleClosedPeriodMonth != "" ? parseInt(this.ProjectSaleList[index].ProjectSaleClosedPeriodMonth) : monthindex,
    //  ProjectSaleExpectedClosePerioddYear: this.ProjectSaleList[index].ProjectSaleClosedPeriodYear != "" ? parseInt(this.ProjectSaleList[index].ProjectSaleClosedPeriodYear) : yearcurrent,
    //  ProjectSaleContactDate: this.ProjectSaleList[index].ProjectSaleContactDate != null && this.ProjectSaleList[index].ProjectSaleContactDate != "" ? this.formatDate(this.ProjectSaleList[index].ProjectSaleContactDate) : null,
    //  ProjectSaleContactPerson: this.ProjectSaleList[index].ProjectSaleContactPerson != null ? this.ProjectSaleList[index].ProjectSaleContactPerson : null,
    //  ProjectSaleContactEmail: this.ProjectSaleList[index].ProjectSaleContactEmail != null ? this.ProjectSaleList[index].ProjectSaleContactEmail : null,
    //  ProjectSaleContactTel: this.ProjectSaleList[index].ProjectSaleContactTel != null ? this.ProjectSaleList[index].ProjectSaleContactTel : null,
    //  ProjectSaleCustomerType: this.ProjectSaleList[index].ProjectSaleCustomerType != null ? parseInt(this.ProjectSaleList[index].ProjectSaleCustomerType) : null,
    //  ProjectSaleRemark: this.ProjectSaleList[index].ProjectSaleRemark != null ? this.ProjectSaleList[index].ProjectSaleRemark : null,
    //  ProjectSaleYear: this.ProjectSaleList[index].ProjectSaleYear != null ? parseInt(this.ProjectSaleList[index].ProjectSaleYear) : yearcurrent,
    //});


    //this.hidProjectSaleId = this.ProjectSaleList[index].ProjectSaleId
    //this.hidProjectSaleState = this.ProjectSaleList[index].ProjectSaleState;
    //$('#ModalProjectSale').modal();

  }
  btnClick_ViewProjectSale(id) {
    $('#ModalProjectSale').modal('hide');
    this.Clearinput();
    this.isOnUpdate = false;
    this.isViewOnly = true;

    this.router.navigateByUrl('/projectsale-information;status=v;id=' + id + '');

    //let index = this.ProjectSaleList.findIndex(x => x.ProjectSaleId == id);

    //// get json object from field SupportTeam
    //this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    //this.itemsSupport.clear();
    //var objectSupportTeamFromJson = [];
    //if (this.ProjectSaleList[index].ProjectSaleSupportTeam != null && this.ProjectSaleList[index].ProjectSaleSupportTeam != '') {
    //  objectSupportTeamFromJson = JSON.parse(this.ProjectSaleList[index].ProjectSaleSupportTeam);
    //}

    //for (let i = 0; i < objectSupportTeamFromJson.length; i++) {
    //  this.itemsSupport.push(this.createItemSupportTeamName(objectSupportTeamFromJson[i].SupporTeamName));
    //}

    //var d = new Date();
    //var monthindex = d.getMonth() + 1;
    //var yearcurrent = d.getFullYear();

    //this.form.patchValue({
    //  ProjectGroupMapping: this.ProjectSaleList[index].ProjectGroupMapping != null ? this.ProjectSaleList[index].ProjectGroupMapping : null,
    //  ProjectSaleCode: this.ProjectSaleList[index].ProjectSaleCode != null ? this.ProjectSaleList[index].ProjectSaleCode : null,
    //  ProjectSaleName: this.ProjectSaleList[index].ProjectSaleName != null ? this.ProjectSaleList[index].ProjectSaleName : null,
    //  ProjectSaleCompanyId: this.ProjectSaleList[index].ProjectSaleCompanyId != null ? this.ProjectSaleList[index].ProjectSaleCompanyId : null,
    //  ProjectSaleStatus: this.ProjectSaleList[index].ProjectSaleStatus != null ? this.ProjectSaleList[index].ProjectSaleStatus : null,
    //  ProjectSaleType: this.ProjectSaleList[index].ProjectSaleType != null ? this.ProjectSaleList[index].ProjectSaleType : null,
    //  ProjectSaleCategory: this.ProjectSaleList[index].ProjectSaleCategoryCode != null ? this.ProjectSaleList[index].ProjectSaleCategoryCode : null,
    //  ProjectSaleTool: this.ProjectSaleList[index].ProjectSaleTool != null ? this.ProjectSaleList[index].ProjectSaleTool : null,
    //  ProjectSalePhase: this.ProjectSaleList[index].ProjectSalePhase != null ? this.ProjectSaleList[index].ProjectSalePhase : null,
    //  ProjectSaleBudget: this.ProjectSaleList[index].ProjectSaleBudget != null ? this.ProjectSaleList[index].ProjectSaleBudget : null,
    //  ProjectSaleExpectedClosePeriodMonth: this.ProjectSaleList[index].ProjectSaleClosedPeriodMonth != "" ? parseInt(this.ProjectSaleList[index].ProjectSaleClosedPeriodMonth) : monthindex,
    //  ProjectSaleExpectedClosePerioddYear: this.ProjectSaleList[index].ProjectSaleClosedPeriodYear != "" ? parseInt(this.ProjectSaleList[index].ProjectSaleClosedPeriodYear) : yearcurrent,
    //  ProjectSaleContactDate: this.ProjectSaleList[index].ProjectSaleContactDate != null && this.ProjectSaleList[index].ProjectSaleContactDate != "" ? this.formatDate(this.ProjectSaleList[index].ProjectSaleContactDate) : null,
    //  ProjectSaleContactPerson: this.ProjectSaleList[index].ProjectSaleContactPerson != null ? this.ProjectSaleList[index].ProjectSaleContactPerson : null,
    //  ProjectSaleContactEmail: this.ProjectSaleList[index].ProjectSaleContactEmail != null ? this.ProjectSaleList[index].ProjectSaleContactEmail : null,
    //  ProjectSaleContactTel: this.ProjectSaleList[index].ProjectSaleContactTel != null ? this.ProjectSaleList[index].ProjectSaleContactTel : null,
    //  ProjectSaleCustomerType: this.ProjectSaleList[index].ProjectSaleCustomerType != null ? parseInt(this.ProjectSaleList[index].ProjectSaleCustomerType) : null,
    //  ProjectSaleRemark: this.ProjectSaleList[index].ProjectSaleRemark != null ? this.ProjectSaleList[index].ProjectSaleRemark : null,
    //  ProjectSaleYear: this.ProjectSaleList[index].ProjectSaleYear != null ? parseInt(this.ProjectSaleList[index].ProjectSaleYear) : yearcurrent,
    //});


    //this.hidProjectSaleId = this.ProjectSaleList[index].ProjectSaleId
    //this.hidProjectSaleState = this.ProjectSaleList[index].ProjectSaleState;
    //$('#ModalProjectSale').modal();
  }

  async btnClick_submitUpdateProjectSale(id, saveType) {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnUpdating('y');
        id = this.hidProjectSaleId

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = id;
        objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleName'].value);
        objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value)) : 0;
        objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString($('#ProjectSaleCompanyId option:selected').attr('companyabbreviation'));
        objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value)) : 0;
        objectjson['ProjectSaleType'] = this.checkUndefinedString(this.form.controls['ProjectSaleType'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleType'].value)) : 0;
        objectjson['ProjectSaleTypeDisplay'] = this.checkUndefinedString($('#ProjectSaleType option:selected').attr('projectsaletypedisplay'));
        objectjson['ProjectSaleCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.checkUndefinedString(this.form.controls['ProjectSaleTool'].value);
        objectjson['ProjectSalePhase'] = this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value)) : 0;
        objectjson['ProjectSalePhaseDisplay'] = this.checkUndefinedString($('#ProjectSalePhase option:selected').attr('projectsalephasedisplay'));
        objectjson['ProjectSaleBudget'] = this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.checkUndefinedString(this.form.controls['ProjectSaleCustomerType'].value)
        objectjson['ProjectSaleSupportTeam'] = this.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.checkUndefinedString(this.form.controls['ProjectSaleRemark'].value);
        objectjson['ProjectSaleUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) ? this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) : null;
        objectjson['ProjectSaleChannelTypeCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelTypeCode'].value);
        objectjson['ProjectSaleChannelMappingCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelMappingCode'].value);
        objectjson['ProjectSaleState'] = saveType;

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnUpdating('n');
          },
            async () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdating('n');
              $('#ModalUpdateComplate').modal();

              var auth_token = await this.TokenService.RefreshToken();
              if (!!auth_token) {
                this.LoadProjectSale();
                this.LoadProjectSaleAll(auth_token);
              }

            }
          )
      } else {
        this.GlobalService.validateAllFormFields(this.form);
      }

    }

  }

  async btnClick_deleteProjectSale(id): Promise<Observable<ProjectSaleInfo[]>> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/DeleteProjectSale", strjsonCusInfo, httpOptions);
    }
  }

  async expenseclaims_deleteProjectSale(id): Promise<Observable<ProjectSaleInfo[]>> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.expense_baseurl + "ProjectSale/DeleteProjectSale", strjsonCusInfo, httpOptions);
    }
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSale"]').prop('checked', check);

  }



  //mark12
  async btnClick_deleteProjectSaleitem(id) {

    if (confirm("Are you sure you want to delete this Project ?" + "\n The project sale to remove all " + "1" + " numbers.")) {
      var currentProject = this.ProjectSaleList.filter(x => { return x.ProjectSaleId == id });
      var isOwner = (currentProject[0].ProjectSaleCreateBy == this._EmpCode || currentProject[0].ProjectSaleAssignTo == this._EmpCode);

      var curState = currentProject[0].ProjectSaleState;

      console.log(" Delete id = " + id + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);

      if (isOwner || (this._RoleCode == "ADMIN")) {

        if (curState == '1-1' || curState == '1-2' || curState == '1-6') {

          (await this.btnClick_deleteProjectSale(parseInt(id))).toPromise()
            .then(
              async data => {
                console.log('หลังรับค่า');

                //delete on expense
                this.expenseclaims_deleteProjectSale(parseInt(id));

                $('#ModalDeleteComplate').modal('show');
                this.currentPageNumber = 1;
                this.indexNo = 0;
                this.isSearchSubmitted = false;

                var auth_token = await this.TokenService.RefreshToken();
                if (!!auth_token) {
                  this.LoadProjectSale();
                  this.LoadProjectSaleAll(auth_token);
                }
              }
            );
        } else {
          debugger
          this.detailmodal = 'Lead is already approved. Edit and delete are prohinited.';
          $('#ModalError .modal-header').text("Sorry");
          $('#ModalError').modal();
        }


      } else {
        //Not owner


      }

    }

  }

  //Delete แบบ list
  async btnClick_onDeleteProjectSaleList() {

    var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

    let num = checkkedProjectSale.length;
    let observableBatch = [];
    let observableBatch2 = [];
    var canDelete = true;
    if (confirm("Are you sure to delete this Project?" + "\n The project sale to remove " + num + " project(s).")) {

      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];

        var curProj = this.ProjectSaleList.find(x => { return x.ProjectSaleId == parseInt(ProjectSalecurrent.value) });
        var curState = curProj.ProjectSaleState
        
        if (curState == '1-1' || curState == '1-2' || curState == '1-6') {
          observableBatch.push((await this.btnClick_deleteProjectSale(parseInt(ProjectSalecurrent.value))).toPromise().then(val => {
          }));

          //for expense
          observableBatch2.push((await this.expenseclaims_deleteProjectSale(parseInt(ProjectSalecurrent.value))).toPromise().then(val => {
          }));
        } else {
          canDelete = false;
          this.detailmodal = 'Lead is already approved. Edit and delete are prohinited.';
          $('#ModalError .modal-header').text("Sorry");
          $('#ModalError').modal();
        }

        //Check
        if (!canDelete)
          break;
      }

      this.currentPageNumber = 1;
      this.indexNo = 0;
      if (canDelete) {
        Promise.all(observableBatch).then(val => {
          this.isSearchSubmitted = false;
          this.SendListIdToDelete(observableBatch);

        });
      }

    }

  }
  async SendListIdToDelete(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`

        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/DeleteListProjectSale", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          async data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            var auth_token = await this.TokenService.RefreshToken();
            if (!!auth_token) {

              this.LoadProjectSale();
              this.LoadProjectSaleAll(auth_token);
            }

          }
        );
    }
  }

  btnClick_onCreateProjectSale() {
    this.form.reset();
    this.Clearinput();
    this.isOnUpdate = false;
    this.isViewOnly = false;

    console.log('isOnUpdate ' + this.isOnUpdate)
    console.log('isViewOnly ' + this.isViewOnly)
    //$('#ModalProjectSale').modal('show');
    this.router.navigateByUrl('/projectsale-information;status=c');
  }

  isFieldValid(field: string) {
    $('#isFieldValid')
    return this.form.get(field).invalid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }





  async loadCompany(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
      .toPromise()
  }

  async loadLookup(lookuptype: string, auth_token: string) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
      .toPromise()
  }
  async LoadStateList(dataId: number = 0): Promise<StateInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['CycleCode'] = "1";

      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<StateInfo[]>(this.baseurl + "MasterSale/GetStateManagementList", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      //$("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);


      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      //$("#btnsubmitProjectSale").show();

      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }

  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      //$("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      //$("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }

  }


  CheckduplicateProjectSaleCode() {
    if (this.isOnUpdate == true) {
      return false;
    }

    var ProjectSaleCode = this.form.controls['ProjectSaleCode'].value;
    let index = this.ProjectSaleList.findIndex(x => x.ProjectSaleCode == ProjectSaleCode);
    var flagreturn = false;
    if (index != -1) {
      flagreturn = true;
    }
    this.flagduplicate = flagreturn;
    return flagreturn;
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  ConvertDate(DateValue) {
    if (DateValue) {

      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daystr = '';

      if (day < 10) {
        daystr = '0' + day
      } else {
        daystr = day.toString();
      }


      var monthIndex = date.getMonth() + 1;
      var monthstr = '';

      if (monthIndex < 10) {
        monthstr = '0' + monthIndex
      } else {
        monthstr = monthIndex.toString();
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();

      var Datenow = '';

      Datenow = monthstr + "/" + daystr + "/" + year;
    }
    else {

      Datenow = null;
    }

    return Datenow;

  }



  displayhyperlink(projectcode: string, projectsaleid: number) {
    var body = ""
    body += " <a href=\"/saletracking-management?ProjectSaleID=" + projectsaleid + "\">" + projectcode + "</a>"

    return body;
  }

  generateArrayOfYears() {
    var max = new Date().getFullYear() + 5
    var min = max - 5
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }

  generateArrayOfPastYears(number) {
    var max = new Date().getFullYear()
    var min = max - number
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }


  async btnonclick_loadcompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadCompany(auth_token).then((data) => {
        this.CompanyList = data;
      });
    }
  }

  async btnonclick_loadCategory() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
        this.CategoryList = data;
      });
    }
  }

  async btnClick_onAssignEmpClick() {
    var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');
    let num = checkkedProjectSale.length;
    if (num > 0) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadEmpforAssign(auth_token);
        $('#ModalEmpAssign').modal('show');
      }
    } else {
      this.titlemodal = '';
      this.detailmodal = 'Please select project at least 1 row.';
      $('#ModalError .modal-header').text("Sorry");
      $('#ModalError').modal();
    }
  }

  ClearSearchEmp() {
    this.form.patchValue({
      EmpCodeSearch: "",
      EmpNameSearch: "",
    });
  }

  async LoadEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadEmpList(auth_token)
        .then(
          data => {
            this.empList = data;
          }
        ).then(() => {
          this.CountEmpList(auth_token);
        })
    }
  }

  LoadEmpList(auth_token): Promise<EmpInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
    objectjson['FlagDelete'] = 'N';
    objectjson['rowFetch'] = environment.PageSizeSmall;
    objectjson['rowOFFSet'] = offset;

    let strjson = JSON.stringify(objectjson);

    this.empListPromise = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
      .toPromise()

    return this.empListPromise;
  }

  CountEmpList(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
    objectjson['FlagDelete'] = 'N';

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmployeeCriteria", strjson, httpOptions)
      .toPromise().then(data => {
      })
      .then(() => {
      })

  }

  async btnClickshowEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadEmpforAssign(auth_token);
    }
  }


  LoadSaleOrganizationLevel(auth_token) {

    this.LoadSaleOrganizationLevelList(auth_token).then(async data => {
      this.saleOrganizationList = data;
      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].AssignFlag == 'Y') {
          this.hidebutton = false;
          this.assignflag = false;
        }
        else {
          this.hidebutton = true;
          this.assignflag = true;
        }
      }
      else {
        this.hidebutton = true;
        this.assignflag = true;
      }

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].ViewFlag == 'Y') {
          this.viewflag = true;
        }
        else {
          this.viewflag = false;
        }
      }
      else {
        this.viewflag = false;
      }

      if (this.saleOrganizationList.length > 0) {
        this.saleorglevelemplogin = this.saleOrganizationList[0].Levels
      }
      else {
        this.saleorglevelemplogin = 1;
      }

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadProjectSale();
        this.LoadProjectSaleAll(auth_token);
      }
    })
      .then(async () => {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          this.LoadSaleOrganizationLevelmax(auth_token);
        }

      });
  }

  LoadSaleOrganizationLevelList(auth_token): Promise<SaleOrganizationInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.empcodeinit);

    let strjson = JSON.stringify(objectjson);

    this.saleOrganizationPromise = this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
      .toPromise()

    return this.saleOrganizationPromise;
  }

  LoadSaleOrganizationLevelmax(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
      .toPromise().then(
        async data => {
          this.saleOrganizationMaxList = data;
          this.saleOrganizationMaxList = this.saleOrganizationMaxList.sort((a, b) => a.Levels - b.Levels);

          if (this.saleOrganizationMaxList.length > 0) {
            this.saleorglevelmax = this.saleOrganizationMaxList[this.saleOrganizationMaxList.length - 1].Levels;

          }
          else {
            this.saleorglevelmax = 1;
          }

          //var auth_token = await this.TokenService.RefreshToken();
          //if (!!auth_token) {
          //  this.LoadEmpforAssign(auth_token);
          //}
        })
  }

  LoadEmpforAssign(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['saleorglevel'] = this.saleorglevelemplogin;
    objectjson['saleorglevelmax'] = this.saleorglevelmax;
    objectjson['rowFetch'] = environment.PageSizeSmall;
    objectjson['rowOFFSet'] = offset;
    objectjson['EmpCode'] = this._EmpCode;
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmpforAssignProjectSale", strjson, httpOptions)
      .toPromise().then(
        async data => {
          this.empListLoad = data;

          if (data.length == 0) {
            $('#ModalEmpAssign').modal('hide');

            this.titlemodal = '';
            this.detailmodal = 'To assign projects, please add sellers to your team at least 1 person.';
            $('#ModalError .modal-header').text("Sorry");
            $('#ModalError').modal();
          }


          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            this.CountLoadEmpforAssign(auth_token);
          }
        }).then(() => {

        }).catch(function (err) {

        });
  }

  CountLoadEmpforAssign(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['saleorglevel'] = this.saleorglevelemplogin;
    objectjson['saleorglevelmax'] = this.saleorglevelmax;
    objectjson['EmpCode'] = this._EmpCode;
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<number>(this.baseurl + "Employee/GetCountEmpforAssignProjectSale", strjson, httpOptions)
      .toPromise().then(data => {
        this.EmpTotal = data;
        if (this.EmpTotal == 0) this.currentPageNumberEmp = 0;
      })
      .then(() => {
        this.totalPagesEmp = Math.ceil(this.EmpTotal / environment.PageSizeSmall);
      })


  }

  GoBack() {
    this.location.back()
  }

  async assignclicked(item) {

    if (confirm("Are you sure you want to assign sale employee?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        $('#ModalEmpAssign').modal('hide');
        let EmpCode = this.empListLoad.findIndex(x => x.Id == item);

        var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

        let num = checkkedProjectSale.length;
        let observableBatch = [];

        for (var i = 0; i < num; i++) {

          var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
          observableBatch.push(this.btnClick_assignProjectSale(parseInt(ProjectSalecurrent.value), item, this._EmpCode, auth_token).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(async val => {
          console.log('สำเร็จ');
          $('#ModalEmpAssignComplate').modal('show');
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            this.LoadProjectSale();
            this.LoadEmpforAssign(auth_token);
          }
        });
      }
    }
  }

  btnClick_assignProjectSale(id, AssignTo, AssignBy, auth_token): Observable<ProjectSaleInfo[]> {


    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ProjectSaleId'] = id;
    objectjson['ProjectSaleAssignTo'] = AssignTo;
    objectjson['ProjectSaleAssignBy'] = AssignBy;
    objectjson['ProjectSaleUpdateBy'] = AssignBy;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/AssignEmpProjectSale", strjsonCusInfo, httpOptions);

  }


  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }

  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {

    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  //Lead group
  //function Update Group projectsale
  //1. Get list project group to modal
  //2. Send list projs id to save 
  //Variables
  listProjGroup: ProjectGroupInfo[] = [];
  totalProjectGroup: number;
  totalPage_ProjectGroup: number;
  currentPageNumber_ProjectGroup: number;

  LoadListProjectGroup(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    this.httpClient
      .post<ProjectGroupInfo[]>(this.baseurl + "Master/GetProjectGroup",
        strjson, httpOptions)
      .subscribe(data => {
        this.listProjGroup = data;
      });
  }
  LoadCountProjectGroup(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    this.httpClient
      .post<number>(this.baseurl + "Master/GetCountProjectGroup",
        strjson, httpOptions)
      .subscribe(data => {

        this.currentPageNumber_ProjectGroup = 1;
        this.totalProjectGroup = data;//จำนวน data ทั้งหมด
        this.totalPage_ProjectGroup = Math.ceil(this.totalProjectGroup / environment.PageSizeSmall);//จำนวนที่แบ่ง page ได้
      });
  }

  async OnLoadProjGroupFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_ProjectGroup = traget.currentPageNumber;
      this.totalPage_ProjectGroup = traget.totalPages;
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadListProjectGroup(auth_token);
    }
  }
  OnBtnOpenProjectGroupModalClick() {
    $('#ModalProjectGroup').modal();
  }
  OnBtnAssignGroupProjectSaleList(groupcode) {

    if (confirm("Are you sure you want to Update group this Project?")) {

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');
      var Groupproject = groupcode;
      let num = checkkedProjectSale.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];

        var projcode = $(ProjectSalecurrent).data('projcode');
        observableBatch.push(this.btnClick_UpdateGroupProjectSale(parseInt(ProjectSalecurrent.value), projcode, Groupproject).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {


        this.SendListIdToUpdateGroup(observableBatch);

      });

    }

  }

  btnClick_UpdateGroupProjectSale(id, projcode, Groupproject): Observable<ProjectSaleInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectSaleCode'] = projcode;
      objectjson['ProjectGroupMapping'] = Groupproject;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSaleByGroup", strjsonCusInfo, httpOptions);
    }
  }

  async SendListIdToUpdateGroup(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSaleByGroup", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalProjectGroupComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();

          }
        );
    }
  }

  //For Pagination
  async OnPaginationLoaded(traget) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumberEmp = traget.currentPageNumber;
      this.totalPagesEmp = traget.totalPages;
    }

    //var auth_token = await this.TokenService.RefreshToken();
    //if (!!auth_token) {

    //  this.LoadEmpforAssign(auth_token);
    //}
  }
    // ------------------------------- Assign BD Zone -----------------------------------------------

  async loadDDLAssignBD() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['RoleCode'] = 'SALEDIRECTOR';  // Business Development

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.AssignBDList = data;
        });
    }
  }


  async btnAssignBDClick(ProjectCode, EmpAssignBD: string) {
    // reset form
    this.AssignBDForm.reset();
    //set current select project
    this.cuurentselectProjectAssignBD = ProjectCode;
    // load ddl AssignPM
    await this.loadDDLAssignBD();

    // set current Assign PM
    this.AssignBDForm.patchValue({
      ddlAssignBD: EmpAssignBD,
    });

    // show modal Assign BD
    $('#ModalAssignBD').modal();
  }

  async btnSubmitAssignBDClick() {
    if (this.AssignBDForm.valid) {
      // hide modal Assign BD
      $('#ModalAssignBD').modal('hide');

      // save AssignPM
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var EmpAssignBD = this.AssignBDForm.get('ddlAssignBD').value;
        var EmpRoleAssignBD = $('#selectAssignBD option:selected').attr('emprolecode');

        var objectjson = {};
        objectjson['EmpCode'] = this.checkUndefinedString(EmpAssignBD.toString());
        objectjson['EmpRole'] = this.checkUndefinedString(EmpRoleAssignBD.toString());
        objectjson['ProjectCode'] = this.checkUndefinedString(this.cuurentselectProjectAssignBD);
        objectjson['ProjectType'] = 'Lead';
        objectjson['PositionInProject'] = '5'; // from lookup MASTERPROJECTROLE 5 = Business Development

        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);


        this.isSubmitted = await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/SaveAssignManagerProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
            this.titlemodal = 'Update Assign fail.';
            this.detailmodal = 'Action Assign BD was update fail.';

            $('#ModalError').modal();

          },
            async () => {
              console.log("Update = " + this.isSubmitted)

              await this.LoadProjectSale();
              await this.LoadProjectSaleAll(auth_token);

              this.titlemodal = 'Submit Assign BD succeed.';
              this.detailmodal = 'Update Assign BD completed.';

              $('#ModalComplate').modal();

            }
          )

      }

    } else {
      //mark FormGroup Touched
      this.GlobalService.validateAllFormFields(this.AssignBDForm)

    }

  }
      // ------------------------------- Assign BD Zone -----------------------------------------------

  // Add new methods
  async loadChannelTypes(auth_token: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {};

      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/GetChannelTypeList",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ChannelTypeList = response;
    } catch (error) {
      console.error('Error loading channel types:', error);
    }
  }

  async loadChannelMapping(auth_token: string, type: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        ChannelTypeCode: this.form.get('ProjectSaleChannelTypeCode').value,
        ChannelMappingType: type,
        ChannelMappingFlagActive: "Y"
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/GetChannelMappingList",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      if (type === 'D') {
        this.ChannelMappingDList = response;
      } else {
        this.ChannelMappingCList = response;
      }
    } catch (error) {
      console.error('Error loading channel mapping:', error);
    }
  }

  async onChannelTypeChange(event: any) {
    const selectedValue = event.target.value;
    const selectedChannel = this.ChannelTypeList.find(x => x.ChannelTypeCode === selectedValue);

    var auth_token = await this.TokenService.RefreshToken();
    
    if (selectedChannel && selectedChannel.ChannelTypeFlagDealer === 'Y') {
      this.isDealerChannel = true;
      await this.loadChannelMapping(auth_token, 'D');
    } else {
      this.isDealerChannel = false;
      await this.loadChannelMapping(auth_token, 'C');
    }
  }

  async LoadRequestFinished() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectSaleId'] = this.hidProjectSaleId;
      objectjson['ProjectSaleState'] = '1-3';

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)
        .subscribe(result => {
          console.log(result);
        });
    }
  }

  LoadRequestFinishedLead(page: any): void {
    this.currentPageNumber_LeadTransac = page.currentPageNumber;

    this.LoadTransaction(this.hidProjectRequestType, this.hidProjectSaleId).then((data) => {
      this.LeadTransaction = data;
    });
    this.LoadCountTansaction(this.hidProjectRequestType, this.hidProjectSaleId);
  }

  async LoadTransaction(RequestType, ProjectSaleId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_LeadTransac - 1) * environment.PageSizeSmall;

      var objectjson = {};
      objectjson['LeadTansactionProjectSaleRequestType'] = RequestType;
      objectjson['LeadTansactionProjectSaleId'] = ProjectSaleId;

      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<LeadTansactionInfo[]>(this.baseurl + "LeadTansaction/GetLeadTansaction",
          strjson, httpOptions)
        .toPromise().then((data) => {
          return data;
        });
    }
  }

  async LoadCountTansaction(RequestType, ProjectSaleId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LeadTansactionProjectSaleRequestType'] = RequestType;
      objectjson['LeadTansactionProjectSaleId'] = ProjectSaleId;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<number>(this.baseurl + "LeadTansaction/GetCountLeadTansaction",
          strjson, httpOptions)
        .subscribe(data => {
          this.totalLeadTransaction = data;
          if(this.totalLeadTransaction == 0) this.currentPageNumber_LeadTransac = 0;
          this.totalPages_LeadTransac = Math.ceil(this.totalLeadTransaction / environment.PageSizeSmall);
        });
    }
  }

  async btnClick_onSuspendProjectSale() {

    var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

    let num = checkkedProjectSale.length;
    let observableBatch = [];
    let observableBatch2 = [];
    var canSuspend = true;
    if (confirm("Are you sure to suspend this Project?" + "\n The project sale to suspend " + num + " project(s).")) {

      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];

        var curProj = this.ProjectSaleList.find(x => { return x.ProjectSaleId == parseInt(ProjectSalecurrent.value) });
        var curState = curProj.ProjectSaleState
        
        if (curState == '1-1' || curState == '1-3' || curState == '1-4'  || curState == '1-8') { // เว้น 1-2, 1-6(Created Lead WF), 1-5(Closed Deal WF)
          // Fix status can suspend
          observableBatch.push((await this.btnClick_suspendProjectSale(parseInt(ProjectSalecurrent.value))).toPromise().then(val => {
            this.currentPageNumber = 1;
            this.indexNo = 0;
            this.LoadProjectSale();
          }));

          //for expense
          //observableBatch2.push((await this.expenseclaims_deleteProjectSale(parseInt(ProjectSalecurrent.value))).toPromise().then(val => {
          //}));
        // ตอนนนี้ยส่วนนี้ยังไม่ลง ไว้เผื่อมีการเพิ่มเงื่อนไขในอนาคต (Relate กับ Case If ปกติ ด้านบน)
        } else if (curState === '1-1') {
          canSuspend = false;
          this.detailmodal = 'สถานะ Created Lead ยังไม่เข้า Workflow Create Lead โปรดใช้การ Delete';
          $('#ModalError .modal-header').text("แจ้งเตือน");
          $('#ModalError').modal();
        } else if (curState === '1-2' || curState == '1-6') {
          canSuspend = false;
          this.detailmodal = 'สถานะ Lead กำลังรอการอนุมัติ Workflow Create Lead';
          $('#ModalError .modal-header').text("แจ้งเตือน");
          $('#ModalError').modal();
        } else if (curState === '1-5' || curState == '1-6') {
          canSuspend = false;
          this.detailmodal = 'สถานะ Lead กำลังรอการอนุมัติ Workflow Close Deal';
          $('#ModalError .modal-header').text("แจ้งเตือน");
          $('#ModalError').modal();
        } else if (curState === '1-8') {
          canSuspend = false;
          this.detailmodal = 'สถานะ Lead Closed แล้ว';
          $('#ModalError .modal-header').text("แจ้งเตือน");
          $('#ModalError').modal();
        } else {
          canSuspend = false;
          this.detailmodal = 'Lead is already approved. Action Suspend are prohinited.';
          $('#ModalError .modal-header').text("Sorry");
          $('#ModalError').modal();
        }

        //Check
        if (!canSuspend)
          break;
      }

      // No update all state project sale to suspend
      //if (canSuspend) {
      //  Promise.all(observableBatch).then(val => {
      //    this.isSearchSubmitted = false;
      //    this.SendListIdToSuspend(observableBatch);
      //  });
      //}
    }
  }

  async btnClick_suspendProjectSale(id): Promise<Observable<ProjectSaleInfo[]>> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectSaleUpdateBy'] = this._EmpCode;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/SuspendProjectSale", strjsonCusInfo, httpOptions);
    }
  }

  async SendListIdToSuspend(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`

        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/SuspendListProjectSale", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          async data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            var auth_token = await this.TokenService.RefreshToken();
            if (!!auth_token) {

              this.LoadProjectSale();
              this.LoadProjectSaleAll(auth_token);
            }

          }
        );
    }
  }

  async btnClick_onTerminateProjectSale() {

    var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

    let num = checkkedProjectSale.length;
    let observableBatch = [];
    let observableBatch2 = [];
    var canSuspend = true;
    if (confirm("Are you sure to terminate this Project?" + "\n The project sale to terminate " + num + " project(s).")) {

      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];

        var curProj = this.ProjectSaleList.find(x => { return x.ProjectSaleId == parseInt(ProjectSalecurrent.value) });
        var curState = curProj.ProjectSaleState
        
        if (curState == '1-1' || curState == '1-3' || curState == '1-4'  || curState == '1-8') { // เว้น 1-2, 1-6(Created Lead WF), 1-5(Closed Deal WF)
          // Fix status can suspend
          observableBatch.push((await this.btnClick_terminateProjectSale(parseInt(ProjectSalecurrent.value))).toPromise().then(val => {
            this.currentPageNumber = 1;
            this.indexNo = 0;
            this.LoadProjectSale();
          }));

          //for expense
          //observableBatch2.push((await this.expenseclaims_deleteProjectSale(parseInt(ProjectSalecurrent.value))).toPromise().then(val => {
          //}));
        // ตอนนนี้ยส่วนนี้ยังไม่ลง ไว้เผื่อมีการเพิ่มเงื่อนไขในอนาคต (Relate กับ Case If ปกติ ด้านบน)
        } else if (curState === '1-1') {
          canSuspend = false;
          this.detailmodal = 'สถานะ Created Lead ยังไม่เข้า Workflow Create Lead โปรดใช้การ Delete';
          $('#ModalError .modal-header').text("แจ้งเตือน");
          $('#ModalError').modal();
        } else if (curState === '1-2' || curState == '1-6') {
          canSuspend = false;
          this.detailmodal = 'สถานะ Lead กำลังรอการอนุมัติ Workflow Create Lead';
          $('#ModalError .modal-header').text("แจ้งเตือน");
          $('#ModalError').modal();
        } else if (curState === '1-5' || curState == '1-6') {
          canSuspend = false;
          this.detailmodal = 'สถานะ Lead กำลังรอการอนุมัติ Workflow Close Deal';
          $('#ModalError .modal-header').text("แจ้งเตือน");
          $('#ModalError').modal();
        } else if (curState === '1-8') {
          canSuspend = false;
          this.detailmodal = 'สถานะ Lead Closed แล้ว';
          $('#ModalError .modal-header').text("แจ้งเตือน");
          $('#ModalError').modal();
        } else {
          canSuspend = false;
          this.detailmodal = 'Lead is already approved. Action Suspend are prohinited.';
          $('#ModalError .modal-header').text("Sorry");
          $('#ModalError').modal();
        }

        //Check
        if (!canSuspend)
          break;
      }

      // No update all state project sale to suspend
      //if (canSuspend) {
      //  Promise.all(observableBatch).then(val => {
      //    this.isSearchSubmitted = false;
      //    this.SendListIdToTerminate(observableBatch);
      //  });
      //}
    }
  }

  async btnClick_terminateProjectSale(id): Promise<Observable<ProjectSaleInfo[]>> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectSaleUpdateBy'] = this._EmpCode;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/TerminateProjectSale", strjsonCusInfo, httpOptions);
    }
  }

  async SendListIdToTerminate(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`

        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/TerminateListProjectSale", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          async data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            var auth_token = await this.TokenService.RefreshToken();
            if (!!auth_token) {

              this.LoadProjectSale();
              this.LoadProjectSaleAll(auth_token);
            }

          }
        );
    }
  }

  onSearchCompanyTextChange(value: string): void {
  this.searchCompanyText = value;
  if (value && value.trim() !== '') {
    this.filteredCompanyList = this.CompanyList.filter(x =>
      (`${x.CompanyCode} ${x.CompanyName}`).toLowerCase().includes(value.toLowerCase())
    );
  } else {
    this.filteredCompanyList = this.CompanyList;
  }
  this.showCompanyDropdown = this.filteredCompanyList.length > 0;
}

  selectCompany(company: any): void {
    this.searchCompanyText = `${company.CompanyCode} - ${company.CompanyName}`;
    this.form.get('ProjectSaleCompanyIdSearch')?.setValue(company.CompanyId); // ✅ ส่ง CompanyId
    this.showCompanyDropdown = false;
  }

  onCompanyInputFocus(): void {
    this.filteredCompanyList = this.CompanyList; // แสดงทั้งหมดทันที
    this.showCompanyDropdown = true;
  }

  onCompanyInputBlur(): void {
    setTimeout(() => {
      this.showCompanyDropdown = false;
    }, 200); // รอให้ mousedown trigger ก่อน blur
  }

  btnClick_onUpdateSecondProjectSale(id) {
    this.router.navigateByUrl('/projectsale-edit;status=u;id=' + id + '');
  }

  async btnClick_onUpdateActivateFromSuspendProjectSale(projectSaleId: number, projectSaleCode: string) {
    //console.log('btnClick_onUpdateActivateFromSuspendProjectSale Click!!', projectSaleId, projectSaleCode);
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
        objectjson['ProjectSaleId'] = projectSaleId;
        objectjson['ProjectSaleCode'] = projectSaleCode;
        objectjson['ProjectSaleUpdateBy'] = this.checkUndefinedString(this._EmpCode);

        //console.log('objectjson', objectjson);
        let strjson = JSON.stringify(objectjson);

        if (confirm("Are you sure to Activate this Project?")) {
        try {
        const result = await this.httpClient.post<boolean>(this.baseurl + "ProjectSale/ActivateProjectSale", strjson, httpOptions)
        .toPromise();

        this.isSubmitted = result;

        if (result === true){
          await this.LoadProjectSale();
        }        
          
        } catch (err) {
            console.error("Insert failed", err);
        } finally {
          //this.OnCreating('n');
        }
      }
  }


}
